import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SearchQueryParams} from '../models/search-query-params.model';
import {mapSearchListResponse} from '../helpers/search.helper';
import {OceanPolicyChanges, OceanPolicyFile, OceanPolicyRegistryItem, SimplifiedOceanPolicy} from '../models/simplified-ocean-policy.model';
import {RepositoryPolicyCancel} from '../models/repository-policy.model';

@Injectable()
export class RepositoryPoliciesService {

    baseUrl = 'api/secured/repository';

    constructor(private http: HttpClient) {
    }

    getRepositoryPoliciesList(props: SearchQueryParams) {
        return this.http
            .get(this.baseUrl, {params: props.getHttpParams(), observe: 'response'})
            .pipe(mapSearchListResponse<OceanPolicyRegistryItem>(OceanPolicyRegistryItem));
    }

    getRepositoryPolicy(policyId: string) {
        return this.http.get<SimplifiedOceanPolicy>(`${this.baseUrl}/${policyId}`);
    }

    getRepositoryPolicyHistoricVersion(policyId: string, version: string = '1') {
        return this.http.get<SimplifiedOceanPolicy>(`${this.baseUrl}/${policyId}?version=${version}`);
    }

    downloadPrintout(policyId: string){
        return this.http.get<{ token: string }>(`${this.baseUrl}/${policyId}/printout`);
    }

    getTerminationReasons(policyId: string) {
        return this.http.get<any>(`${this.baseUrl}/${policyId}/cancel-reasons`);
    }

    termination(policyId: string, data: RepositoryPolicyCancel, save: boolean) {
        // save = false, when you just want to check payback amount, save = true, when you want to save termination
        return this.http.post<SimplifiedOceanPolicy>(`${this.baseUrl}/${policyId}/cancel?save=${save}`, data);
    }

    dataChange(policyId: string, data: OceanPolicyChanges) {
        return this.http.post<OceanPolicyChanges>(`${this.baseUrl}/${policyId}/edit`, data);
    }

    getDocuments(policyId: string) {
        return this.http.get<any>(`${this.baseUrl}/${policyId}/files`);
    }

    addDocument(policyId: string, document: OceanPolicyFile) {
        return this.http.post(`${this.baseUrl}/${policyId}/files`, {...document});
    }

    getRepositoryTokenByHash(policyId: string, hash: string, name: string) {
        this.http.get<{ token: string }>(`${this.baseUrl}/${policyId}/files/${hash}`)
            .subscribe(response => {
                this.getFileByToken(response.token, name);
            });
    }

    public getFileByToken(token: string, name: string) {
        window.location.href = `${this.baseUrl}/files/${token}/${name}`;
    }
}
